const darkSelectStyles = {
  control: (base:any, state:any) => ({
    ...base,
    backgroundColor: "black", // Tailwind gray-800
    color: "#FFF",
    boxShadow: state.isFocused ? "0 0 0 1px #3b82f6" : "none",
    "&:focus": {
      color: "#fff",
    },
    width: "100%",
  }),
  menu: (base:any) => ({
    ...base,
    backgroundColor: "black",
    color: "#f9fafb",
    width: "100%",
  }),
  option: (base:any, state:any) => ({
    ...base,
    backgroundColor: state.isFocused
      ? "black"
      : state.isSelected
      ? "#8b5bba"
      : "#0F0F1A",
    color: state.isSelected ? "#fff" : "#fff",
    "&:hover": {
      backgroundColor: "black",
    },
    width: "100%",
  }),
  singleValue: (base:any) => ({
    ...base,
    color: "#f9fafb",
    width: "100%",
  }),
  placeholder: (base:any) => ({
    ...base,
    color: "#fff",
    width: "100%",
  }),
  input: (base: any) => ({
    ...base,
    color: "#fff", // Makes typed text white
  }),
};
export default darkSelectStyles